#import "./confluence-comment-fragment.graphql"

mutation UpdateInlineComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    ...CommentFragment
    replies {
      ...CommentFragment
    }
  }
}
